<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-card v-if="item">
      <v-toolbar color="primary" dense dark class="elevation-0">
        <v-toolbar-title>Phê duyệt Đề xuất Mua sắm</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-4">
        <v-form ref="form" v-model="valid">
          <v-card outlined class="pa-3 grey lighten-5 mb-4">
            <div class="mb-1"><span class="grey--text">Mã đề xuất:</span> <strong class="primary--text">{{ item.code }}</strong></div>
            <div class="mb-1"><span class="grey--text">Tiêu đề:</span> <strong>{{ item.title }}</strong></div>
            <div class="mb-1"><span class="grey--text">Người đề xuất:</span> {{ item.proposer }} ({{ item.department || '-' }})</div>
            <div class="mb-1">
              <span class="grey--text">Tổng dự toán ban đầu:</span>
              <strong class="success--text ml-1">{{ (item.totalEstimatedCost || 0).toLocaleString('vi-VN') }} đ</strong>
            </div>
          </v-card>

          <v-text-field
            v-model.number="approvedBudget"
            type="number"
            min="0"
            outlined
            dense
            :rules="[
              v => (v !== null && v !== undefined && v !== '') || 'Vui lòng nhập ngân sách phê duyệt',
              v => v >= 0 || 'Ngân sách phải lớn hơn hoặc bằng 0'
            ]"
          >
            <template v-slot:label>
              Ngân sách phê duyệt (VNĐ) <span class="red--text font-weight-bold">*</span>
            </template>
          </v-text-field>

          <v-textarea
            v-model="note"
            label="Ghi chú / Chỉ đạo của Ban Giám hiệu"
            placeholder="VD: Đồng ý duyệt mua sắm đợt 1, giao phòng CSVC liên hệ đơn vị cung ứng..."
            outlined
            dense
            rows="3"
          />
        </v-form>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="dialog = false">Hủy</v-btn>
        <v-spacer />
        <v-btn color="success" depressed :loading="loading" @click="onConfirm">
          <v-icon left small>mdi-check</v-icon> Xác nhận phê duyệt
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ProposalApproveDialog',
  props: {
    state: Boolean,
    item: Object
  },
  data() {
    return {
      dialog: false,
      loading: false,
      valid: true,
      approvedBudget: 0,
      note: ''
    }
  },
  watch: {
    state(val) {
      if (val && this.item) {
        this.dialog = true
        this.approvedBudget = this.item.totalEstimatedCost || 0
        this.note = this.item.note || ''
        if (this.$refs.form) {
          this.$refs.form.resetValidation()
        }
      }
    }
  },
  methods: {
    ...mapActions('FacilityProposals', ['updateProposal']),
    async onConfirm() {
      if (!this.$refs.form.validate()) return
      if (!this.item || !this.item.id) return

      this.loading = true
      try {
        const res = await this.updateProposal({
          id: this.item.id,
          status: 'APPROVED',
          approvedBudget: this.approvedBudget,
          note: this.note
        })
        if (res) {
          this.dialog = false
          this.$emit('updated')
        }
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
